import React from 'react'
import Skeleton from 'react-loading-skeleton'

import AdCardListItem from '../../../../../../features/components/AdCardListItem'
import AdCardMetrics from '../../../../../../features/components/AdCardListItem/AdCardMetrics'
import AdCardMetricSkeleton from '../../../../../../features/components/AdCardListItem/AdCardMetrics/AdCardMetric/AdCardMetricSkeleton'

import useStyles from './styles'

function SkeletonOnsiteAdCardListItem() {
  const classes = useStyles()

  return (
    <AdCardListItem>
      <div className={classes.onsiteAdPreview}>
        <Skeleton style={{ minHeight: '120px' }} />
      </div>
      <AdCardMetrics>
        <AdCardMetricSkeleton />
        <AdCardMetricSkeleton />
      </AdCardMetrics>
    </AdCardListItem>
  )
}

export default SkeletonOnsiteAdCardListItem
